import { render } from "./moviesEditor.vue?vue&type=template&id=2eab873f"
import script from "./moviesEditor.vue?vue&type=script&lang=js"
export * from "./moviesEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__